export default __webpack_public_path__ + "static/media/dashboard-seedj.2ab9ba91.png";